<template>
  <div class="kunde-new-container">
    <div class="d-flex justify-content-between align-items-center page-header">
      <h2><i class="fas fa-user-plus me-2"></i>Neuer Kunde</h2>
      <div>
        <button
            class="btn btn-outline-secondary me-2"
            @click="navigateBack">
          <i class="fas fa-arrow-left me-1"></i>Zurück
        </button>

        <button
            class="btn btn-primary"
            @click="submitForm"
            :disabled="loading || !formIsValid">
          <i class="fas fa-save me-1"></i>Speichern
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="errorMessage" class="alert alert-danger mb-4">
          {{ errorMessage }}
        </div>

        <form @submit.prevent="submitForm">
          <div class="row mb-4">
            <div class="col-12">
              <h5 class="section-title">Unternehmensdaten</h5>
            </div>

            <div class="col-md-6 mb-3">
              <label for="name" class="form-label">Firmenname *</label>
              <input
                  type="text"
                  id="name"
                  v-model="kunde.k_name"
                  class="form-control"
                  :class="{ 'is-invalid': validationErrors.k_name }"
                  required
              >
              <div v-if="validationErrors.k_name" class="invalid-feedback">
                {{ validationErrors.k_name }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="namezusatz" class="form-label">Namenszusatz</label>
              <input
                  type="text"
                  id="namezusatz"
                  v-model="kunde.k_namezusatz"
                  class="form-control"
              >
            </div>

            <div class="col-md-6 mb-3">
              <label for="branche" class="form-label">Branche</label>
              <input
                  type="text"
                  id="branche"
                  v-model="kunde.k_branche"
                  class="form-control"
              >
            </div>

            <div class="col-md-6 mb-3">
              <label for="status" class="form-label">Status *</label>
              <select
                  id="status"
                  v-model="kunde.k_status"
                  class="form-select"
                  :class="{ 'is-invalid': validationErrors.k_status }"
                  required
              >
                <option :value="1">Aktiv</option>
                <option :value="0">Inaktiv</option>
              </select>
              <div v-if="validationErrors.k_status" class="invalid-feedback">
                {{ validationErrors.k_status }}
              </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <h5 class="section-title">Kontaktdaten</h5>
            </div>

            <div class="col-md-6 mb-3">
              <label for="anschrift" class="form-label">Straße</label>
              <input
                  type="text"
                  id="anschrift"
                  v-model="kunde.k_anschrift"
                  class="form-control"
              >
            </div>

            <div class="col-md-3 mb-3">
              <label for="plz" class="form-label">PLZ</label>
              <input
                  type="text"
                  id="plz"
                  v-model="kunde.k_plz"
                  class="form-control"
              >
            </div>

            <div class="col-md-3 mb-3">
              <label for="ort" class="form-label">Ort</label>
              <input
                  type="text"
                  id="ort"
                  v-model="kunde.k_ort"
                  class="form-control"
              >
            </div>

            <div class="col-md-6 mb-3">
              <label for="land" class="form-label">Land</label>
              <input
                  type="text"
                  id="land"
                  v-model="kunde.k_land"
                  class="form-control"
              >
            </div>

            <div class="col-md-6 mb-3">
              <label for="tel" class="form-label">Telefon</label>
              <input
                  type="tel"
                  id="tel"
                  v-model="kunde.k_tel"
                  class="form-control"
              >
            </div>

            <div class="col-md-6 mb-3">
              <label for="mail" class="form-label">E-Mail</label>
              <input
                  type="email"
                  id="mail"
                  v-model="kunde.k_mail"
                  class="form-control"
                  :class="{ 'is-invalid': validationErrors.k_mail }"
              >
              <div v-if="validationErrors.k_mail" class="invalid-feedback">
                {{ validationErrors.k_mail }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="page" class="form-label">Website</label>
              <input
                  type="url"
                  id="page"
                  v-model="kunde.k_page"
                  class="form-control"
                  placeholder="https://example.com"
              >
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <h5 class="section-title">Weitere Informationen</h5>
            </div>

            <div class="col-12 mb-3">
              <label for="bemerkung" class="form-label">Bemerkungen</label>
              <textarea
                  id="bemerkung"
                  v-model="kunde.k_bemerkung"
                  class="form-control"
                  rows="3"
              ></textarea>
            </div>
          </div>

          <div class="text-end">
            <button
                type="button"
                class="btn btn-outline-secondary me-2"
                @click="navigateBack">
              Abbrechen
            </button>

            <button
                type="submit"
                class="btn btn-primary"
                :disabled="loading || !formIsValid">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
              Kunde speichern
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import apiClient from '@/api'

export default {
  name: 'KundeNew',

  data() {
    return {
      kunde: {
        k_name: '',
        k_namezusatz: '',
        k_branche: '',
        k_anschrift: '',
        k_plz: '',
        k_ort: '',
        k_land: 'Deutschland', // Default value
        k_tel: '',
        k_mail: '',
        k_page: '',
        k_status: 1, // Default to active
        k_bemerkung: ''
      },
      validationErrors: {},
      errorMessage: '',
      loading: false
    }
  },

  computed: {
    ...mapGetters(['isAuthenticated']),

    formIsValid() {
      // Basic validation: at least name is required
      return this.kunde.k_name && this.kunde.k_name.trim() !== ''
    }
  },

  methods: {
    ...mapActions(['fetchData']),

    validateForm() {
      this.validationErrors = {}
      let isValid = true

      // Name validation
      if (!this.kunde.k_name || this.kunde.k_name.trim() === '') {
        this.validationErrors.k_name = 'Firmenname ist erforderlich'
        isValid = false
      }

      // Email validation (if provided)
      if (this.kunde.k_mail && !this.isValidEmail(this.kunde.k_mail)) {
        this.validationErrors.k_mail = 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
        isValid = false
      }

      // Status validation
      if (this.kunde.k_status === undefined || this.kunde.k_status === null) {
        this.validationErrors.k_status = 'Status ist erforderlich'
        isValid = false
      }

      return isValid
    },

    isValidEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },

    async submitForm() {
      if (!this.validateForm()) {
        return
      }

      this.loading = true
      this.errorMessage = ''

      try {
        // Use the API client to submit the form
        const response = await apiClient.post('kunden', this.kunde)

        // Show success notification
        this.$toast.success('Kunde wurde erfolgreich erstellt')

        // Navigate back to the clients list
        this.$router.push('/kunden')
      } catch (error) {
        console.error('Error creating customer:', error)

        // Handle API errors
        if (error.status === 422 && error.data) {
          // Validation errors from the server
          this.validationErrors = error.data.errors || {}
          this.errorMessage = 'Bitte korrigieren Sie die markierten Felder'
        } else {
          // Generic error message
          this.errorMessage = error.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
        }
      } finally {
        this.loading = false
      }
    },

    navigateBack() {
      this.$router.push('/kunden')
    }
  }
}
</script>
<style scoped>
.kunde-new-container {
  font-family: 'Inter', sans-serif;
}

.page-header {
  margin-bottom: 1.5rem;
}

.page-header h2 {
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: -0.5px;
  margin: 0;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.card {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: none;
}

.form-label {
  font-weight: 500;
  font-size: 0.9rem;
}

.form-control, .form-select {
  padding: 0.6rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ced4da;
}

.form-control:focus, .form-select:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.btn {
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
}

.btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
</style>